export const SET_ACTIVE_OPERATION = 'SET_ACTIVE_OPERATION'
